import '../styles/Footer.css'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuthUser } from './components_index';
import { useState } from 'react';


export default function Footer() {
  const location = useLocation();
  const navigate = useNavigate();
  const path = location.pathname;
  const { role, loginID } = useAuthUser();
  const [profilePerson, setProfilePerson] = useState("");

  function handleChange(e) {
    const value = e.target.value;
    setProfilePerson(value)
  }

  function handleKeyPress(e) {
    if (e.key === "Escape") {
      setProfilePerson("");
      e.target.blur();
    }
    if (e.key === "Enter") {
      handleSearch();
    }
  }

  function handleSearch() {
    if (profilePerson.length === 7 && profilePerson[0] === 'P') {
      navigate(`/profile/${profilePerson}`)
      setProfilePerson("")
    }
  }

  return (
    <div className='footer-root'>
      <div className='site-footer'>
        {(role === "admin") && 
          <>
            <Link to='/edit-person'>
              Add/Edit Person
            </Link>
            <Link to='/edit-reunion'>
              Add/Edit Reunion
            </Link>
            <Link to='/edit-img'>
              Add Imgs/Videos
            </Link>
            <Link to='/edit-photos'>
              Edit All Photos
            </Link>
            <input
              id='profile-search'
              className='footer-input'
              type='text'
              placeholder='Profile'
              value={profilePerson}
              onChange={handleChange}
              onKeyDown={handleKeyPress}
              autoComplete='off'
            />
            <button className='footer-button' onClick={handleSearch}>
              Go to profile
            </button>
          </>
        }
        {(path === `/people/${loginID}`) && 
          <Link to='/edit-bio'>
            Edit Your Bio Page
          </Link>
        }
      </div>
    </div>
  )
}